function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import shared, { paddingBlockStartEnd, paddingInlineStartEnd } from "./shared";
import { blue10, blue15, blue25, blue30, blue40, text120, white } from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";
import hexToRgba from "hex2rgba";
const Component = styled.button.withConfig({
  componentId: "sc-11cmx9o-0"
})(["", ";padding:calc(", " - 1px) calc(", " - 1px);", ";", ";@media (hover:hover){&:hover{border-width:2px;padding:calc(", " - 2px) calc(", " - 2px);", "}}&:active{", "}&[disabled],&[disabled]:hover{padding:calc(", " - 1px) calc(", " - 1px);", "}"], shared, paddingBlockStartEnd, paddingInlineStartEnd, _ref => {
  let {
    inverted
  } = _ref;
  return inverted ? `background-color: ${hexToRgba(blue15, 0.08)}` : `background-color: ${white}`;
}, _ref2 => {
  let {
    inverted
  } = _ref2;
  return inverted ? `color: ${blue15};
         border: 1px solid ${blue15};
        ` : `color: ${blue30};
         border: 1px solid ${blue30};
        `;
}, paddingBlockStartEnd, paddingInlineStartEnd, _ref3 => {
  let {
    inverted
  } = _ref3;
  return inverted ? `color: ${blue10};
            border-color: ${blue10};
            background-color: ${hexToRgba(blue15, 0.16)}` : `color: ${blue25};
            border-color: ${blue25};`;
}, _ref4 => {
  let {
    inverted
  } = _ref4;
  return inverted ? `background-color: transparent;
          color: ${blue15};
          border-color: ${blue15}` : `background-color: ${blue40};
          color: ${white};
          border-color: ${blue40}`;
}, paddingBlockStartEnd, paddingInlineStartEnd, _ref5 => {
  let {
    inverted
  } = _ref5;
  return inverted ? `color: ${hexToRgba(white, 0.38)};
       border: 1px solid ${hexToRgba(white, 0.38)};
       background: transparent;
      ` : `color: ${hexToRgba(text120, 0.38)};
        border: 1px solid ${hexToRgba(text120, 0.38)};
        background: transparent;
      `;
});
/**
 * On components with multiple buttons this should be the default style used. This button style indicates that an action is a viable path to choose when completing a task. This style is subservient to the Primary button style.
 */

const Secondary = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
  ref: ref,
  as: props.disabled ? "button" : props.href ? "a" : "button"
}), props.children));
Secondary.defaultProps = {
  type: "button"
};
Secondary.displayName = "Secondary";
Secondary.propTypes = {
  /** The button contents */
  children: PropTypes.node.isRequired,

  /** Whether to apply styles that help the button stand out on a dark background */
  inverted: PropTypes.bool,

  /** Whether to apply smaller styles */
  small: PropTypes.bool,

  /** The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes), if an href is present it will be the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes) */
  type: PropTypes.string,

  /** If the button should expand to the full width of its parent */
  fullWidth: PropTypes.bool,

  /** If the button should be disabled */
  disabled: PropTypes.bool,

  /** The link that the button should navigate to on click */
  href: PropTypes.string
};
export default Secondary;